import options from './thing-location.component';

export default {
    selector: 'dtEditThingLocation',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-location/index.js